// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K1JyCH_uBK_s0QxuAN53 {
    padding: 16px;
    border-bottom: 1px solid #E5E5E5;
}

.D0AP3roOn3aTeFoKpr5Y {
    font-size: 18px;
    margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletDistribution/DashboardWalletDistribution.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB","sourcesContent":[".distribution {\n    padding: 16px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.title {\n    font-size: 18px;\n    margin-top: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"distribution": `K1JyCH_uBK_s0QxuAN53`,
	"title": `D0AP3roOn3aTeFoKpr5Y`
};
export default ___CSS_LOADER_EXPORT___;
